import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowNE.svg",
  "use": "ArrowNE.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ArrowNE.svg\"><path d=\"M46,41a2,2,0,0,1-2-2V22.8449l-24.6,24.6a1.9895,1.9895,0,1,1-2.8018-2.8252L41.2181,20H25a2,2,0,1,1,0-4H46a2,2,0,0,1,2,2V39A2,2,0,0,1,46,41Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol